export const SRAVNI_TELEGRAM = 'https://t.me/SravniSupport_bot';
export const SRAVNI_WHATSAPP = 'https://api.whatsapp.com/send/?phone=79250233848&text&type=phone_number&app_absent=0';
